/**
 * PushStatusLabel — what the drawer's Status says about pushes: paused (the
 * per-campaign kill switch), held (the tracker's switch), or active.
 * Split out of KillSwitchBanner (over the function limit); the paused and
 * active markup is unchanged.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import { AlertTriangle } from 'lucide-react';

import HeldStatusLabel from '@/features/flow-optimizer/components/kill-switch/HeldStatusLabel';

export interface PushStatusLabelProps {
  paused: boolean;
  /** Tracker display name, e.g. "Voluum". */
  tracker: string;
  /** Why the tracker's optimizer is held, or null (never for Voluum/Binom). */
  heldReason: string | null;
}

const PushStatusLabel: FC<PushStatusLabelProps> = ({ paused, tracker, heldReason }) => {
  if (paused) {
    return (
      <>
        <AlertTriangle className="h-3 w-3 shrink-0 text-destructive" aria-hidden />
        <span className="text-[11px] font-medium leading-none text-destructive">
          Pushes paused — no writes to {tracker}
        </span>
      </>
    );
  }
  if (heldReason) return <HeldStatusLabel tracker={tracker} reason={heldReason} />;
  return (
    <>
      <span
        className="h-1.5 w-1.5 shrink-0 rounded-full bg-success shadow-[0_0_0_2px_rgba(34,197,94,0.18)]"
        aria-hidden
      />
      <span className="text-[11px] leading-none text-muted-foreground">Pushes active</span>
    </>
  );
};

export default PushStatusLabel;
